import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import ABCyaLib from '@abcya/abcya_lib';

export default class AnalogClock extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.buttonSprite = null;
    this.buttontext = null;
    this.enabled = true;
    this.doAction = null;
    this.clickSound = null;
    this.number = 0;
    this.lastDegree = 0;
    this.littleHandLastDegree = 0;
    this.currentHour = 0;
    this.minutesArray = [];
    this.totalAngle = 0;
    this.lastAngle = 0;
    this.timeLabel = 'PM'; // should be AM or PM and NOT localized

    this.clockFace = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._analog_clock_face, this);

    this.makeNightDayButton();

    this.bigHand = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._big_hand, this).setOrigin(0.5, 1)
      .setInteractive({ draggable: true });

    this.littleHand = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._small_hand, this).setOrigin(0.5, 1);

    this.bigHand.on(Phaser.Input.Events.GAMEOBJECT_DRAG, this.handlePress, this);

    this.setHoursAndMinutes(12,0,'PM');
  }

  makeNightDayButton () {
    this.pmButton = ABCyaPhaser.Images.addImage(0,80, UIAssetKeys._pm_button, this).setInteractive();

    this.dayNightLabel = ABCyaPhaser.Text.addText(0, ABCyaLib.Environment.instance.gameConfig.analogTimeLabelY, 42, 0xffffff, FontKeys._dimboregular, 'PM', this, false).setOrigin(0.5);

    this.pmButton.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doButtonClick, this);
  }

  doButtonClick () {
    if (this.timeLabel === 'AM') {
      this.timeLabel = 'PM';
      this.updateTimeLabel();
    }
    else {
      this.timeLabel = 'AM';
      this.updateTimeLabel();
    }

    this.emit('CHANGED');
  }

  handlePress (pointer) {
    const localPt = this.getLocalPoint(pointer.x, pointer.y);

    const x = localPt.x;
    const y = localPt.y;

    const cX = 0;
    const cY = 0;

    let angle = 90 + Math.atan2(y - cY , x - cX) * (180 / Math.PI);

    if (angle < 0) {
      angle += 360;
    }

    const diffAngle = angle - this.lastAngle;

    if (diffAngle > 270) {
      this.currentHour--;
    }
    else if (diffAngle < -270) {
      this.currentHour++;
    }

    this.lastAngle = angle;

    // we want the hand to 'click' on the minutes as it moves,
    // so we'll round to nearest 6 degrees (6 x 60 = 360)

    const remainder = angle % 6;

    const angleMinusRemainder = angle - remainder;
    const times = angleMinusRemainder / 6;

    const degrees = times * 6;

    this.bigHand.angle = degrees;

    if (this.currentHour === 12) {
      this.currentHour = 0;
      if (this.timeLabel === 'AM') {
        this.timeLabel = 'PM';
        this.updateTimeLabel();
      }
      else {
        this.timeLabel = 'AM';
        this.updateTimeLabel();
      }
    }

    if (this.currentHour < 0) {
      this.currentHour = 11;
      if (this.timeLabel === 'AM') {
        this.timeLabel = 'PM';
        this.updateTimeLabel();
      }
      else {
        this.timeLabel = 'AM';
        this.updateTimeLabel();
      }
    }

    if (degrees !== this.lastDegree) {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._tick, this.scene);
      this.emit('CHANGED');
    }

    this.lastDegree = degrees;

    const littleHandDegree = (this.currentHour * 30) + (degrees / 360) * 30;
    const diffDegree = Math.abs(this.littleHandLastDegree - littleHandDegree);

    if (diffDegree < 5) {
      this.littleHand.angle = littleHandDegree;
    }
    this.littleHandLastDegree = littleHandDegree;
  }

  getHoursAndMinutes () {
    let hours = this.currentHour % 12;

    if (hours === 0) {
      hours = 12;
    }

    const angle = Phaser.Math.Angle.Normalize(this.bigHand.rotation) * Phaser.Math.RAD_TO_DEG;
    const minutesRotation = angle % 360;
    let minutes = Math.round(minutesRotation / 6);

    if (minutes === 60) {
      minutes = 0;
    }

    return [hours, minutes, this.timeLabel];
  }

  setHoursAndMinutes (hour, minutes, timeOfDay) {
    this.timeLabel = timeOfDay;
    this.updateTimeLabel();

    this.currentHour = hour;

    if (hour === 12) {
      this.currentHour = 0;
    }

    const degrees = minutes * 6;

    this.bigHand.angle = degrees;

    this.littleHand.angle = (this.currentHour * 30) + (degrees / 360) * 30;
  }

  updateTimeLabel() {
    this.dayNightLabel.text = ABCyaPhaser.Localization.instance.getLocalizedString(`time_labels.${this.timeLabel === 'AM' ? 'ante_meridiem' : 'post_meridiem'}`);
    ABCyaPhaser.Text.resizeFontToFitWidth(this.dayNightLabel, 65, null, 42);
  }
}